import * as Sentry from '@sentry/vue';
import type { App } from 'vue';
import type { Router } from 'vue-router';

import { sentryBreadcrumbEnhancement } from '@/features/Sentry/breadcrumbEnhancement/sentryBreadcrumbEnhancement';
import {
  getSentryDistSetting,
  getSentryDsn,
  getSentryEnv,
  getSentryReleaseVersion,
  getSentryTransactionRate,
} from '@/features/Sentry/sentryEnv';
import { isDev } from '@/utils/environments/environments';
import { generateUUID } from '@/utils/uuid/uuid';

export const sentrySessionId = generateUUID();

export const initSentry = (app: App, router: Router): void => {
  if (isDev()) {
    console.warn('Sentry is disabled in development mode');
    return;
  }

  Sentry.init({
    app,
    dsn: getSentryDsn(),
    environment: getSentryEnv(),
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracePropagationTargets: [
      '/(localhost|vergleichsrechner(-v2)*.local)(:[0-9]+)?',
      '/(w+.)*vergleichsrechner.professional.works',
    ],
    tracesSampleRate: getSentryTransactionRate(),

    // needed so source maps can get matched correctly
    release: getSentryReleaseVersion(),
    dist: getSentryDistSetting(),

    beforeBreadcrumb: sentryBreadcrumbEnhancement,

    ignoreErrors: ['CanceledError'],
  });

  Sentry.setTag('session', sentrySessionId);
  Sentry.setTag('sessionStart', new Date().toISOString());
};
